import {
  fetchCheckinRewardsConfigDocument,
  fetchConsecutiveDaysDocument,
  fetchCustomerCheckinDocument,
  fetchCustomerCheckinRecordsDocument,
  fetchCustomerPrizeRecordsDocument,
} from '../graphql/docs';
import { fetcher } from '../graphql/fetcher';

/**
 * 获取签到配置
 * @returns
 */
export const fetchCheckinRewardsConfig = async () => {
  const res = await fetcher.query(fetchCheckinRewardsConfigDocument, {
    variables: {},
  });
  return res.data.value?.checkinRewardsConfig;
};

/**
 * 获取签到记录
 * @returns
 */
export const fetchCustomerCheckinRecords = async (input: AnyObject) => {
  const res = await fetcher.query(fetchCustomerCheckinRecordsDocument, {
    variables: { input },
  });
  return res.data.value?.customerCheckinRecords;
};

/**
 * 获取连签天数
 * @returns
 */
export const fetchConsecutiveDays = async () => {
  const res = await fetcher.query(fetchConsecutiveDaysDocument, {
    variables: {},
  });
  return res.data.value?.consecutiveDays;
};

/**
 * 获取连签奖励
 * @returns
 */
export const fetchCustomerPrizeRecords = async () => {
  const res = await fetcher.query(fetchCustomerPrizeRecordsDocument, {
    variables: {},
  });
  return res.data.value?.customerPrizeRecords;
};

/**
 * 签到
 * @returns
 */
export const fetchCustomerCheckin = async () => {
  const res = await fetcher.mutation(fetchCustomerCheckinDocument, {});
  return res.data?.customerCheckin;
};
